import { useTypedParams } from '@sorare/routing';

import { CollectionLayout } from '@sorare/gameplay/src/components/collections/CollectionLayout';

import { LayoutParams } from './__generated__/routeParams';

const NBACollectionLayout = () => {
  const { slug, collectionSlug } = useTypedParams<LayoutParams>();

  return (
    <CollectionLayout collection={collectionSlug} userSlug={slug} fromMyClub />
  );
};

export default NBACollectionLayout;
